var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeliveryinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  transform: "translate(1 10)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42 7.793h9.252a2 2 0 0 1 1.312.49l8.748 7.602a2 2 0 0 1 .688 1.51v17.553h0-20z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 39.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.5,
  cy: 39.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 13.788V3.182C3 1.909 3.803 0 5 0h35c1.197 0 2 1.91 2 3.182V35H5c-1.197 0-2-.849-2-2.121v-8.485M0 15h19m23 3h19m-38-3h2m22 8h2"
}))));
export default SvgDeliveryinline;